import api from "./Api";

class OrdemServicoItemService {
  GetOrdemServicoItem(payload) {
    return api.get("/v1/ordemServicoItem/" + payload).then((response) => {
      return response.data;
    });
  }

  PostOrdemServicoItem(payload) {
    return api.post("/v1/ordemServicoItem/", payload).then((response) => {
      return response.data;
    });
  }

  PutOrdemServicoItem(payload) {
    return api.put("/v1/ordemServicoItem/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteOrdemServicoItem(payload) {
    return api.delete("/v1/ordemServicoItem/" + payload).then((response) => {
      return response.data;
    });
  }

  GetOrdemServicoItemOData(payload) {
    return api.get("/OData/OrdemServicoItem" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new OrdemServicoItemService();
